import { Type } from '@angular/core';
import { map } from 'lodash';

import { Partners } from '@lockton-apps/shared/interfaces';

import { PncComponentTemplates } from './pnc';
import { COMPLIANCE_TEMPLATES } from './pnc/risk-review/templates';
import { DocumentOptions } from '../interfaces';

interface DocumentTemplatePartial {
  id: string;
  component: Type<unknown>;
  initialValues?: Record<string, unknown>;
}

export interface DocumentTemplate {
  name: string;
  front?: DocumentTemplatePartial;
  back?: DocumentTemplatePartial;
  options?: DocumentOptions;
  styles?: string;
}

export const DOCUMENT_TEMPLATES: Record<
  number,
  Record<string, DocumentTemplate>
> = {
  [Partners.PNC]: {
    'pnc-rr': {
      name: 'Risk Review',
      front: {
        id: 'pnc-rr-front',
        component: PncComponentTemplates.riskReview.front,
        initialValues: {
          disclosure: COMPLIANCE_TEMPLATES.disclosure,
        },
      },
      back: {
        id: 'pnc-rr-back',
        component: PncComponentTemplates.riskReview.back,
      },
      options: {
        breakAfterSection: true,
      },
      styles: `
        @page {
          @bottom-left {
            margin: 10pt 0 30pt 0;
            content: 'Lockton Commercial | Risk Review';
            font-size: 9pt;
          }
        }
        @page:first {
          margin: 0;
        }

        .pagedjs_page:last-child .pagedjs_margin-bottom {
          opacity: 0
        }

      `,
    },
    'pnc-rp': {
      name: 'Risk Presentation',
      front: {
        id: 'pnc-rp-front',
        component: PncComponentTemplates.riskPresentation.front,
        initialValues: {
          summaryLabels:
            '<h3 class="mt-0"><strong>Renewal Date</strong></h3><h3><strong>Reporting Deadline</strong></h3><h3><strong>Current Broker</strong></h3><h3><strong>Current Insurer</strong></h3><h3><strong>Target Premium</strong></h3>',
          summaryValues:
            '<h3 class="mt-0"></h3><h3></h3><h3></h3><h3></h3><h3></h3>',
        },
      },
      back: {
        id: 'pnc-rp-back',
        component: PncComponentTemplates.riskPresentation.back,
      },
      options: {
        breakAfterSection: true,
      },
      styles: `
        @page {
          @bottom-left {
            margin: 10pt 0 30pt 0;
            content: 'Lockton Commercial | Risk Presentation';
            font-size: 9pt;
          }
        }
        @page:first {
          margin: 0;
        }

        @page:nth(2) {
          margin: 0;
        }
        .pagedjs_page:last-child {
          --pagedjs-margin-left: 0;
          --pagedjs-margin-right: 0;
          --pagedjs-margin-bottom: 0;
          --pagedjs-margin-top: 0;

        }
        .pagedjs_page:last-child .pagedjs_pagebox {
          display: block;
        }
      `,
    },
  },
} as const;

export function getPartnerTemplates(partnerId: number) {
  return map(DOCUMENT_TEMPLATES[partnerId], (template, key) => ({
    key,
    template,
  }));
}

export function getTemplate(partnerId: number, templateId: string) {
  return DOCUMENT_TEMPLATES[partnerId][templateId];
}
